const TrustpilotStars = ({ count }) => (
    <div className="review-tp-stars">
        {Array.from({ length: 5 }).map((_, i) => (
            <span key={i} className={`review-tp-star ${i < count ? 'filled' : ''}`}>
                <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M10 1.5L12.47 7.03L18.5 7.67L14 11.74L15.26 17.67L10 14.64L4.74 17.67L6 11.74L1.5 7.67L7.53 7.03L10 1.5Z"
                        fill="#ffffff"
                    />
                </svg>
            </span>
        ))}
    </div>
);

export default TrustpilotStars;
